import { Component, EventEmitter, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../../Model/Common/common.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-thumbnail-attachment',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './thumbnail-attachment.component.html',
  styleUrl: './thumbnail-attachment.component.scss'
})
export class ThumbnailAttachmentComponent {
   @Input() attachmentUrl: string = '';
   @Input() borderradius: string = '20%';

  constructor(
    protected common: CommonService,
    protected sanitizer: DomSanitizer,
  ){}
}

